import { createAction } from "@reduxjs/toolkit";

const alert = createAction("alert/set");

export default { alert };
